import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-code-dialog-box',
  templateUrl: './code-dialog-box.component.html',
  styleUrls: ['./code-dialog-box.component.scss'],
})
export class CodeDialogBoxComponent implements OnInit {
  selectedValue: string;
  codeForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showTable = false;
  showSubmitButton = true;
  codeList: any;
  list;
  CodeSearchForm;
  APIService: any;
  isReadonly = false;
  isReadonlyDelete = false;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  codeTypeList: any;
  filteredCodeType: any;
  desLabel: any;
  x = sessionStorage.getItem('CdType');
  y = sessionStorage.getItem('CdDesc');
  CdCode;
  CdType;
  CodeType: string;
  @Output() prev = new EventEmitter<void>();
  userPermission: any;
  utp: string;
  CodeCreate = true;
  CodeUpdate = true;
  CodeDelete = true;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.CdCode = sessionStorage.getItem('CdCode');
    this.CdType = sessionStorage.getItem('CdType');
    this.x = sessionStorage.getItem('CdType');
    this.y = sessionStorage.getItem('CdDesc');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach((element) => {
        if (element.PageName == 'Code' && element.PCreate == false) {
          this.CodeCreate = false;
        }
        if (element.PageName == 'Code' && element.PUpdate == false) {
          this.CodeUpdate = false;
        }
        if (element.PageName == 'Code' && element.PDelete == false) {
          this.CodeDelete = false;
        }
      });
    }
    let k = this.CdType;
    this.list = true;
    this.showTable = false;
    this.submitButton = true;
    this.editButton = false;
    this.isReadonly = false;
    this.isReadonlyDelete = false;
    this.deleteButton = false;
    this.codeForm = this.fb.group({
      CdType: new FormControl(sessionStorage.getItem('CdType')),
      CdCode: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
        Validators.maxLength(6),
      ]),
      CdDesc: new FormControl('', [Validators.required]),
      CdSeq: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(4),
      ]),
      CdActive: new FormControl('Y'),
      CdProc: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),
      ]),
      desLabel: new FormControl(this.y),
    });
    this.CodeSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getCodeData(k);
  }

  prepopulation(id) {
    this.isReadonlyDelete = false;
    this.isReadonly = true;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.codeForm = this.fb.group({
      CdType: new FormControl(id.CdType, [Validators.required]),
      CdCode: new FormControl(id.CdCode, [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9-&]*$'),
        Validators.maxLength(6),
      ]),
      CdDesc: new FormControl(id.CdDesc, [Validators.required]),
      CdSeq: new FormControl(id.CdSeq, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.maxLength(4),
      ]),
      CdActive: new FormControl(id.CdActive, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]*$'),
      ]),
      CdProc: new FormControl(id.CdProc, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),
      ]),
      desLabel: new FormControl(this.y),
    });
    this.redirect('code');
  }

  update() {
    if (this.codeForm.invalid) {
      this.codeForm.get('CdType').markAsTouched();
      this.codeForm.get('CdCode').markAsTouched();
      this.codeForm.get('CdDesc').markAsTouched();
      this.codeForm.get('CdSeq').markAsTouched();
      this.codeForm.get('CdActive').markAsTouched();
      this.codeForm.get('CdProc').markAsTouched();
      return;
    } else {
      this.updateCode();
    }
  }

  updateCode() {
    this.spinner.show();
    this.submitpayload = this.codeForm.value;
    this.umsService.updateCode(this.submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  getCodeData(id) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = id;
    payload['IsActive'] = 0;
    this.umsService.getCode(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide()
          this.codeList = res.data;
          if (res.data.length == 0) {
            this.showTable = false;
          } else {
            this.showTable = true;
          }
        }
        else{
          this.spinner.hide()
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        this.codeList = [];
      }
    );
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      // this.getCodeData();
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  prepopulationForDelete(id) {
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
    this.isReadonlyDelete = true;
    this.isReadonly = true;
    this.codeForm = this.fb.group({
      CdType: new FormControl(id.CdType, [Validators.required,Validators.pattern('^[a-zA-Z0-9]*$'),]),
      CdCode: new FormControl(id.CdCode, [Validators.required,Validators.pattern('^[a-zA-z0-9-&]*$'),Validators.maxLength(6),]),
      CdDesc: new FormControl(id.CdDesc, [Validators.required]),
      CdSeq: new FormControl(id.CdSeq, [Validators.required,Validators.pattern('^[0-9]*$'),Validators.maxLength(4),]),
      CdActive: new FormControl(id.CdActive, [Validators.required,Validators.pattern('^[a-zA-Z0-9]*$'),]),
      CdProc: new FormControl(id.CdProc, [Validators.required,Validators.pattern('^[a-zA-Z0-9 ( /,.)]*$'),]),
    });
  }

  openConformationModalBox() {
    let data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deletedata(this.codeForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }

  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        CdType: id.CdType,
        CdCode: id.CdCode,
        CdDesc: id.CdDesc,
        CdSeq: id.CdSeq,
        CdActive: id.CdActive,
        CdProc: id.CdProc,
      },
    };
    this.httpClient
      .delete(this.APIService + '/masters/code', options)
      .subscribe(
        (s) => {
          this.spinner.hide();
          let cc = [];
          cc.push(s);
          let data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        }
      );
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      // this.getCodeData(i);
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.isReadonly = false;
      this.isReadonlyDelete = false;
      this.codeForm.reset();
    } else {
      this.list = true;
      this.ngOnInit();
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
      this.isReadonly = false;
      this.isReadonlyDelete = false;
    }
  }

  submit() {
    if (this.codeForm.invalid) {
      this.codeForm.get('CdType').markAsTouched();
      this.codeForm.get('CdCode').markAsTouched();
      this.codeForm.get('CdDesc').markAsTouched();
      this.codeForm.get('CdSeq').markAsTouched();
      this.codeForm.get('CdActive').markAsTouched();
      this.codeForm.get('CdProc').markAsTouched();
      return;
    } else {
      this.createCode();
    }
  }

  createCode() {
    this.spinner.show();
    const payload = this.codeForm.value;
    this.umsService.addCode(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchCodeType(id) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = '99999';
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.codeList = res.data;
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getList(i) {
    this.getCodeData(i);
  }

  back() {
    this.prev.emit();
  }
}